import React, { useState, useEffect } from 'react';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { CreateModal } from '../_modals/CreateModal';
import {
  formatDateMonth,
  formatTime,
  formatPhoneNumber,
  KTSVG,
  LoadingGrid,
} from '../../../../_mexablock/helpers';
import { Filter } from '../../pagos/pagados/components/Filter';
import { useGetAll } from '../hooks/CancelationHook';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');

  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [dateState, setDateState] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    search: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  // Disparar recarga cuando cambien los filtros
  useEffect(() => {
    if (initFilterValues.init_date || initFilterValues.end_date || initFilterValues.search) {
      setReloadGrid(Math.random() * 40);
    }
  }, [initFilterValues.init_date, initFilterValues.end_date, initFilterValues.search]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const addRegister = () => {
    setVisivilityModal(!visivilityModal);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/;

    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
      setInitFilterValues((prev) => ({ ...prev, search: inputValue }));
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: values.init_date,
      end_date: values.end_date,
    }));
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      search: '',
    });
    setDateState([]);
    setInputValue('');
    setSearchFilter('');
    setReloadGrid(Math.random() * 40); // Forzar recarga al limpiar
  };

  const columns: any = [
    {
      id: 'created_at',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },

    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row.iccid,
      sortable: true,
      width: '20%',
    },

    {
      id: 'customer.first_name',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) =>
        row.customer
          ? `${row.customer?.first_name} ${row.customer?.father_last_name}`
          : 'Sin cliente',
      sortable: true,
    },

    {
      id: 'customer.creator',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        row.creator
          ? `${row.creator?.first_name} ${row.creator?.father_last_name}`
          : 'Sin usuario',
      sortable: true,
    },
  ];

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="d-flex align-items-center gap-4">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
                <div className="d-flex align-items-center position-relative me-4">
                  <span
                    className="position-absolute ms-3"
                    style={{ zIndex: 10 }}
                  >
                    <i className="bi bi-search fs-4 text-muted"></i>
                  </span>

                  <input
                    type="text"
                    className="form-control form-control-solid ps-9"
                    placeholder="ICCID"
                    maxLength={19}
                    value={inputValue}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="card-title align-items-start flex-column"></div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  className="btn btn-sm btn-light-primary"
                  id="kt_toolbar_primary_button"
                  onClick={addRegister}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Cancelar línea
                </a>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <CreateModal
        id_row={0}
        title={titleModal}
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModal(!visivilityModal);
        }}
      ></CreateModal>
    </>
  );
};

export { View };
